export const REFRESH_ORDER_ITEMS = 'REFRESH_ORDER_ITEMS';
export const LIST_ORDERS = 'LIST_ORDERS';
export const STORE_ORDERS = 'STORE_ORDERS';
export const GET_ORDERS_BY_ORDER_ID = 'GET_ORDERS_BY_ORDER_ID';
export const STORE_ORDER_RESPONSE = 'STORE_ORDER_RESPONSE';
export const GET_MARKETPLACE_COMPANIES = 'GET_MARKETPLACE_COMPANIES';
export const GET_MARKETPLACE_NAMES_BY_COMPANY = 'GET_MARKETPLACE_NAMES_BY_COMPANY';
export const STORE_MARKETPLACE_COMPANIES = 'STORE_MARKETPLACE_COMPANIES';
export const STORE_MARKETPLACE_NAMES_BY_COMPANY = 'STORE_MARKETPLACE_NAMES_BY_COMPANY';
export const FETCH_WALMART_ORDERS_BY_DATE_RANGE = 'FETCH_WALMART_ORDERS_BY_DATE_RANGE';
export const STORE_WALMART_ORDERS = 'STORE_WALMART_ORDERS';
export const CLEAR_WALMART_ORDERS = 'CLEAR_WALMART_ORDERS';